import bdrhApi from '../../../api/hr/bdrh'

// initial state
const state = {
  info: null
}

// getters
// const getters = {
// getMaskDocNum: (state) => {
//   if (state.info === null) { return null }
//   if (!state.info.docNum) {
//     let first5Chars = state.info.docNum.slice(0, 5)
//     return first5Chars.padEnd(state.info.docNum.length, '*')
//   }
// }
// }

// actions
const actions = {
  getStaff ({ commit }) {
    bdrhApi.getStaff(staff => {
      commit('setStaff', staff)
    })
  }
}

// mutations
const mutations = {
  setStaff (state, staff) {
    state.info = staff
  }
}

export default {
  namespaced: true,
  state,
  // getters,
  actions,
  mutations
}
